import { cn } from '../lib/utils';

type DivProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

export function DesktopView({ children, className, ...props }: DivProps) {
  return (
    <div className={cn('hidden sm:block', className)} {...props}>
      {children}
    </div>
  );
}

export function MobileView({ children, className, ...props }: DivProps) {
  return (
    <div className={cn('block sm:hidden', className)} {...props}>
      {children}
    </div>
  );
}
